import { useContext, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { UserContext } from "../Contexts/UserContext";
import { useLocation, useNavigate } from "react-router";

const SelectOrgModal = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { selectedOrgId } = useContext(UserContext);
    const [orgId, setOrgId] = useState(selectedOrgId);
    const [orgName, setOrgName] = useState('');
    const [orgSettings, setOrgSettings] = useState({
        id: 0,
        name: '',
        hideAnnotations: false
    });
    const [userOrgs, setUserOrgs] = useState(props.userOrgs ?? []);
    const orgChangeImpactedPages = ["/timeline", "/"];

    useEffect(() => {
        if (props.userOrgs?.length == 1) {
            props.onOrgSelect(props.userOrgs[0].orgId, getFirstOrg());
            navigate("/portfolio");
            return;
        }
        if(selectedOrgId == null || selectedOrgId == 0) {
            setOrgId(props.userOrgs[0].orgId);
            setOrgSettings(getFirstOrg());
        }
        setUserOrgs([...props.userOrgs].sort((a, b) => a.orgName.toLowerCase().localeCompare(b.orgName.toLowerCase())));
    }, [props.userOrgs]);

    const onOrgSelect = (orgId) => {
        const selectedOrg = getOrg(orgId);
        setOrgId(orgId);
        setOrgName(selectedOrg.name);
        setOrgSettings(selectedOrg);
    };

    const goToOrg = () => {
        props.onOrgSelect(orgId, orgSettings);
        if(orgChangeImpactedPages.some((page) => location.pathname.includes(page)))
            navigate("/portfolio");
    };

    const cancelOrgSelection = () => {
        if (selectedOrgId == null || selectedOrgId == 0) {
            props.onOrgSelect(props.userOrgs[0].orgId, getFirstOrg());
            navigate("/portfolio");
        }
        props.setShowSelectOrgModal(false);
    };

    const getOrg = (orgId) => {
        const selectedOrg = props.userOrgs?.find(o => o.orgId == orgId);
        return {
            id: orgId,
            name: selectedOrg.orgName,
            ...selectedOrg.orgSettings
        };
    };

    const getFirstOrg = () => {
        return {
            id: props.userOrgs[0].orgId,
            name: props.userOrgs[0].orgName,
            ...props.userOrgs[0].orgSettings
        };
    };

    return (
        <Modal
            show={() => props.setShowSelectOrgModal(true)}
            onHide={cancelOrgSelection}
            backdrop="static"
            keyboard={false}
            dialogClassName="modal-600 select-org-modal-dialog"
            className="select-org-modal"
        >
            {
                props.userOrgs?.length == 1 ?
                <>
                    <div style={{textAlign: 'center'}}>Redirecting to {props.userOrgs[0].orgName}</div>
                </> :
                <>
                    <Modal.Header closeButton>
                        <Modal.Title>Choose the Organization</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form-group">
                            <label className="form-label" htmlFor="Organization List">Select Organization :</label>
                            <select className="form-select" id="" onChange={(e) => onOrgSelect(e.target.value)} value={orgId}>
                                {
                                    userOrgs &&
                                    userOrgs.map(org => <option value={org.orgId} key={org.orgId}>{org.orgName}</option>)
                                }
                            </select>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="btn-area">
                            <a onClick={cancelOrgSelection} className="btn btn-text">Cancel</a>
                            <button type="button" className="btn btn-primary" aria-label="Submit" onClick={goToOrg}>
                                Go To {orgName}
                            </button>
                        </div>
                    </Modal.Footer>
                </>
            }
            
        </Modal>
    );
}

export default SelectOrgModal;